/**
 * 描述：新华社稿
 * 日期：2017-8-22
 * 作者：Bai.Zhiming
 */
'use strict';
angular.module('resourceCenterXJRBModule').directive('xjrbLeft', [
    'resourceCenterService',
    '$stateParams',
    function(resourceCenterService, $stateParams) {
        return {
            restrict: 'E',
            replace: true,
            templateUrl: './resourceCenter/XJRB/left/left_tpl.html',
            scope: {
                selectedParent: '=',
            },
            link: function($scope, $elem, $attr) {
                initStatus();

                /**
                 * [selectLeve3 description] 选中新华社稿三级菜单
                 * @param  {[type]} item [description] 三级菜单信息
                 * @return {[type]}      [description]
                 */
                $scope.selectLeve3 = function(item) {
                    $scope.status.selected = item.nodename;
                    let params = {
                        nodename: item.nodename,
                        fcode: item.fcode,
                    };
                    resourceCenterService.go('front.resourcectrl.xjrb.resource', params);
                };

                /**
                 * [initStatus description] 初始化状态
                 * @return {[type]} [description]
                 */
                function initStatus() {
                    $scope.status = {};
                    $scope.data = {};
                    $scope.status.selected = getInitSelected();
                    watchParent();
                }

                /**
                 * [watchParent description] 监控父节点变化
                 * @return {[type]} [description]
                 */
                function watchParent() {
                    $scope.$watch('selectLeve3', (newV, oldV) => {
                        if (newV.fcode === oldV.fcode) {
                            return;
                        }
                        console.log('nodename change');
                        $scope.status.selected = '';
                    });
                }

                /**
                 * [getInitSelected 初始化选中的菜单项]
                 *
                 * @return  {[type]}  [return description]
                 */
                function getInitSelected(){
                    let nodename = $stateParams.nodename;
                    console.log('nodename', nodename);
                    return nodename;
                }
            },
        };
    },
]);
